import { useState, useEffect, useRef } from 'react'
import WeaverService from 'Services/WeaverService'
import { Button, List, Layout, Input, Spin, Tooltip, Modal } from 'antd'
import { ChangelogButton, SupportButton } from 'Components'
import { Link, Redirect } from 'react-router-dom'
import { LogIn, LogOut, Settings, Key, Users } from 'react-feather'
import { track } from 'Integrations/segment'
import { ChangePassword } from 'Components'
import './ProjectSwitcher.scss'

{ Search } = Input

export default ProjectSwitcher = ({ onSelectProject }) ->

  searchBox = useRef()
  [loading, setLoading] = useState(true)
  [projects, setProjects] = useState(true)
  [filteredProjects, setFilteredProjects] = useState([])
  [changePassword, setChangePassword] = useState(false)

  useEffect(->
    (->
      projectList = await WeaverService.listProjects()
      userProjects = _.sortBy(projectList, (p) -> p.name().toLowerCase())
      setProjects(userProjects)
      setFilteredProjects(userProjects)
      setLoading(false)
      track('Project Switcher Opened', {
        project: Weaver.getInstance().currentProject()?.id()
        user: Weaver.getInstance().currentUser().username
      })
    )()
    undefined
  , [])

  onSearch = ({ target: { value }}) =>

    filteredProjects = projects.filter((project) ->
      project.name().toLowerCase().indexOf(value.toLowerCase()) isnt -1
    )
    setFilteredProjects(filteredProjects)

  if loading
    <Spin style={{ padding: 50, width: '100%' }} />
  else
    <Layout style={{ background: 'var(--background)' }}>
      <div className="search-container">
        <Search
          data-testid='search-spaces'
          ref={searchBox}
          placeholder="Search spaces"
          onChange={onSearch}
        />
      </div>
      <List
        dataSource={filteredProjects}
        style={{ marginTop: '8px', overflow: 'auto', maxHeight: '66vh' }}
        renderItem={(item) =>
          <List.Item style={border: 'none'}>
            <Link onClick={onSelectProject} to="/#{item.id()}">{ item.name() }</Link>
          </List.Item>
        }
      />
    </Layout>
